import React, { useState, useContext } from 'react'
import { AuthContext } from '../auth/auth'

const UserProfile = () => {

    const { currentUser } = useContext(AuthContext);

    return (
        <>
            <div className="container-fluid" style={{ height: "100%" }}>
                <div className="container shadow-sm my-5 p-2">
                    <div className="row ">
                        <div className="col-lg-2 col-md-2 col-sm-12 text-center my-3">
                            <img src={currentUser.photoURL ? currentUser.photoURL :
                                "https://st3.depositphotos.com/13159112/17145/v/600/depositphotos_171453724-stock-illustration-default-avatar-profile-icon-grey.jpg"}
                                style={{ borderRadius: "50%", width: "120px", height: "120px" }} />
                        </div>
                        <div className="col-lg-10 col-md-10 col-sm-12 my-auto mx-auto">
                            <h4 className="text-primary font-weight-bold">{currentUser.displayName ? currentUser.displayName : ""}</h4>
                            <h5 >{currentUser.email ? currentUser.email : ""}</h5>
                        </div>
                    </div>
                </div>
                <div className="container my-5">
                    <h3 className="text-center text-primary">Your Courses Will Appear Here!</h3>
                </div>
            </div>
        </>
    )
}

export default UserProfile
